import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Hidden} from "@irati/ui/src/FormItem"
import getActiveQuestions from "@irati/insights/apollo/helpers/question/getActiveQuestions"

export const PROPERTY = "preferences.questionCount"
export const INCLUDE_DRIVER_COMMENT = "preferences.includeDriverComment"

class CustomQuestionCount extends Component {
  static propTypes = {
    cycle: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    questions: PropTypes.array.isRequired,
    deletedQuestionGroupUuid: PropTypes.string
  }

  static defaultProps = {
    deletedQuestionGroupUuid: null
  }

  getCustomQuestionCount = () => {
    const {cycle, questions, deletedQuestionGroupUuid} = this.props
    const activeQuestions = getActiveQuestions(questions, deletedQuestionGroupUuid)
    const includeDriverComment = get(cycle, INCLUDE_DRIVER_COMMENT)
    return includeDriverComment
      ? activeQuestions.length + 1
      : activeQuestions.length
  }

  componentDidUpdate() {
    const {cycle} = this.props
    if (get(cycle, PROPERTY) !== this.getCustomQuestionCount()) {
      this.setProperty()
    }
  }

  setProperty = () => {
    const {onChange, questions} = this.props
    onChange(null, PROPERTY, this.getCustomQuestionCount(questions))
  }

  render() {
    const {cycle} = this.props
    return (
      <Hidden
        name={PROPERTY}
        value={get(cycle, PROPERTY)} />
    )
  }
}


export default CustomQuestionCount
